module.exports = __webpack_public_path__ + "static/media/intro.29130ec1.jpg";